/**
  * froala_editor v4.0.16 (https://www.froala.com/wysiwyg-editor)
  * License https://froala.com/wysiwyg-editor/terms/
  * Copyright 2014-2022 Froala Labs
  *
  * Updates have been made for the purpose of the bridges project.
  * The original code can be found at https://cdn.jsdelivr.net/npm/froala-editor@4.0.16/js/plugins/url.min.js
  *
  * The following changes have been made:
  *
  * Added the following event listeners to the _init function:
  * - 'draft.set'
  * - 'send.before'
  *
  * Modified the 'n' function:
  * - Renamed to 'parse' to deal with conflicts when trying to do recursion.
  * - Changed the function to accept an optional starting node to check for links.
  *   The normal behavior checks the node of the current selection's 0th range (which is the node the cursor is in).
  *   The new behavior allows you to optionally provide a node to check.
  *   This will also recursively check all child nodes of the provided node.
  *   All text nodes that contain a link will be wrapped in an anchor tag.
  *   If the node is not provided as an argument, the function will behave as normal which is far more limited.
  *
  * The URLRegEx property has been updated to have better url detection for urls within text.
  *
  * Replaced the `l.helpers.isURL` call with `p().test` to check if the url is valid.
  *
  */
! function(e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(require("froala-editor")) : "function" == typeof define && define.amd ? define(["froala-editor"], t) : t(e.FroalaEditor)
}(this, function(r) {
  "use strict";
  (r = r && r.hasOwnProperty("default") ? r["default"] : r).URLRegEx = "(^|\\s|\\u00A0)(".concat(r.LinkRegEx, "|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\\.[a-z0-9+-_]{1,}))(?=$|\\s|\\u00A0)"), r.PLUGINS.url = function(l) {
    var s = l.$,
      o = null;

    function t(e, t, n) {
      for (var r = ""; n.length && "." == n[n.length - 1];) r += ".", n = n.substring(0, n.length - 1);
      var a = n;
      if (l.opts.linkConvertEmailAddress) l.helpers.isEmail(a) && !/^mailto:.*/i.test(a) && (a = "mailto:".concat(a));
      else if (l.helpers.isEmail(a)) return t + n;
      return /^((http|https|ftp|ftps|mailto|tel|sms|notes|data)\:)/i.test(a) || (a = "//".concat(a)), (t || "") + "<a".concat(l.opts.linkAlwaysBlank ? ' target="_blank"' : "").concat(o ? ' rel="'.concat(o, '"') : "", ' data-fr-linked="true" href="').concat(a, '">').concat(n.replace(/&amp;/g, "&").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;"), "</a>").concat(r)
    }
    var p = function p() {
      return new RegExp(r.URLRegEx, "gi")
    };

    function u(e) {
      return l.opts.linkAlwaysNoFollow && (o = "nofollow"), l.opts.linkAlwaysBlank && (l.opts.linkNoOpener && (o ? o += " noopener" : o = "noopener"), l.opts.linkNoReferrer && (o ? o += " noreferrer" : o = "noreferrer")), e.replace(p(), t)
    }

    function c(e) {
      var t = e.split(" ");
      return t[t.length - 1]
    }

    function parse(t) {
      // t - the node to be parsed
      // e - the current selection range
      var e = l.selection.ranges(0);
      var checkFull = !!t;
      if (!t) {
        t = e.startContainer;
        if (t?.nodeType !== Node.TEXT_NODE) return !1;
      }
      else {
        if (t.nodeType !== Node.TEXT_NODE) {
          var res = 0;
          for (var cn of t.childNodes) {
            res = res || parse(cn);
          }
          return res;
        }
      }
      if (!t || (t === e.startContainer && e.startOffset !== (t.textContent || "").length)) {
        l.markers.insert();
        var n = l.$el.find(".fr-marker"),
          r = t.textContent.match(/(^|\s|\u00A0)(((([a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,})(\.(com|net|org|edu|mil|gov|co|biz|info|me|dev)))|((ftp|http|https):\/\/[a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,})|(www\.[a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,}\.[a-z0-9-]{2,24})|((ftp|http|https):\/\/[\u0021-\uffff]{1,}@[a-z\u0080-\u009f\u00a1-\uffff0-9-_\.]{1,}))((:[0-9]{1,5})|)(((\/|\?|#)[a-z\u00a1-\uffff0-9@?\|!^=%&amp;\/~+#-\'*-_{}]*)|())|([a-z0-9+-_.]{1,}@[a-z0-9+-_.]{1,}\.[a-z0-9+-_]{1,}))(?=$|\s|\u00A0)/gi);
        if (n.remove(), !r) return !1
      }
      if (function f(e) {
          return !!e && ("A" === e.tagName || !(!e.parentNode || e.parentNode == l.el) && f(e.parentNode))
        }(t)) return !1;
      var textContent = checkFull ? t.textContent : c(t.textContent);
      if (p().test(textContent)) {
        s(t).before(u(t.textContent));
        var a = s(t.parentNode).find("a[data-fr-linked]");
        a.removeAttr("data-fr-linked"), t.parentNode.removeChild(t), l.events.trigger("url.linked", [a.get(0)])
      } else if (t.textContent.split(" ").length <= 2 && t.previousSibling && "A" === t.previousSibling.tagName) {
        var o = t.previousSibling.innerText + t.textContent;
        if (p().test(c(o))) {
          var i = (new DOMParser).parseFromString(u(o), "text/html").body.childNodes;
          t.parentNode.replaceChild(i[0], t.previousSibling), i.length && s(t).before(i[0]), t.parentNode.removeChild(t)
        }
      } else if (checkFull && p().test(c(t.textContent))) {

      }
    }
    return {
      _init: function e() {
        l.events.on("keypress", function(e) {
          !l.selection.isCollapsed() || ")" != e.key && "(" != e.key || parse()
        }, !0), l.events.on("keydown", function(e) {
          var t = e.which;
          !l.selection.isCollapsed() || t != r.KEYCODE.ENTER && t != r.KEYCODE.SPACE || parse()
        }, !0), l.events.on("draft.set", function(e) {
          !l.selection.isCollapsed() || parse(l.$el[0])
        }, !0), l.events.on("send.before", function(e) {
          !l.selection.isCollapsed() || parse(l.$el[0])
        }, !0), l.events.on("paste.beforeCleanup", function(e) {
          if (p().test(e)) {
            var t = null;
            return l.opts.linkAlwaysBlank && (l.opts.linkNoOpener && (t ? t += " noopener" : t = "noopener"), l.opts.linkNoReferrer && (t ? t += " noreferrer" : t = "noreferrer")), "<a".concat(l.opts.linkAlwaysBlank ? ' target="_blank"' : "").concat(t ? ' rel="'.concat(t, '"') : "", ' href="').concat(e, '" >').concat(e, "</a>")
          }
          if (l.$el[0].getAttribute("plainpaste")) return function n(e) {
            if ("string" == typeof e) return e.replace(/(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim, u).replace(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gim, u)
          }(e)
        })
      }
    }
  }
});
